<template>
    <div class="mb-6 space-y-4">
        <form-errors :store-form-errors="portalContentAndDesignStore.loginFormErrors"/>
        
        <div>
            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_email"
                for-attribute="email"
                class="block text-sm opacity-80 mb-1.5"
                :class="getPageContentTextColorClass"
                text-type="label"
            >
            </editable-text-field>
            <input
                type="email"
                name="email"
                id="email"
                v-model="portalContentAndDesignStore.loginFormData.email"
                :readonly="portalContentAndDesignStore.loginEmailLocked"
                required
                :class="getEmailInputClasses"
            >
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../../../stores/partners/portalContentAndDesignStore";
import FormErrors from "../../../Errors/FormErrors.vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

// Referral portal specific text color class
const getPageContentTextColorClass = computed(() => {
    const textColor = portalContentAndDesignStore.portalLayoutSettings?.referral_portal_content_text_color || 'gray-800';
    
    if (textColor.startsWith('#')) {
        return 'text-content-custom-text';
    } else {
        return `text-${textColor}`;
    }
});

// Email input styling based on referral portal settings
const getEmailInputClasses = computed(() => {
    const inputStyle = portalContentAndDesignStore.portalLayoutSettings?.referral_portal_content_input_style || 'white';
    const corners = portalContentAndDesignStore.portalLayoutSettings?.referral_portal_content_layout_corners || 'rounded-xl';
    const textColor = portalContentAndDesignStore.portalLayoutSettings?.referral_portal_content_text_color || 'gray-800';
    
    const classes = [
        'transition-shadow block w-full text-sm px-3.5 py-3.5',
        'border-0 ring-1 ring-inset ring-gray-300 focus:ring-gray-400'
    ];
    
    // Input style (background)
    if (inputStyle === 'white') {
        classes.push('bg-white text-gray-900');
    } else {
        if (textColor.startsWith('#')) {
            classes.push('bg-transparent text-content-custom-text');
        } else {
            classes.push(`bg-transparent text-${textColor}`);
        }
    }
    
    // Corners
    if (corners === 'none') {
        classes.push('rounded');
    } else {
        classes.push(corners);
    }
    
    return classes.join(' ');
});
</script>
